export enum SidenavMode {
    SIDE = 'side',
    OVER = 'over'
  }
